import React, { Component } from 'react';

import bible from './components/bible';
import filterVersions from './components/filterVersions';
import Navigation from './components/Navigation';
import Body from './components/Body';

const initialState = {
  ...Object.assign(window.pageData, {
    hasError: false,
    errorText: '',
    versionId: '',
    versions: [],
    loadingVersions: true,
    bookId: '',
    books: [],
    loadingBooks: true,
    chapterId: '',
    chapters: [],
    loadingChapters: true,
    body: {},
    loadingBody: true,
    searchTerm: '',
    displayingSearch: false,
    searchResults: {},
    loadingSearchResults: false,
  }),
};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { ...initialState };
    this.setCurrent = this.setCurrent.bind(this);
    this.fetchBody = this.fetchBody.bind(this);
    this.updateVersion = this.updateVersion.bind(this);
    this.updateBook = this.updateBook.bind(this);
    this.fetchBooks = this.fetchBooks.bind(this);
    this.updateChapter = this.updateChapter.bind(this);
    this.fetchChapters = this.fetchChapters.bind(this);
    this.setChapter = this.setChapter.bind(this);
    this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
    this.fetchSearchResults = this.fetchSearchResults.bind(this);
    this.clearError = this.clearError.bind(this);
  }

  componentDidMount() {
    const {
      apiKey,
      language,
      defaultVersion,
      defaultBook,
      defaultChapter,
    } = this.state;
    this.setState({
      versionId: defaultVersion,
      bookId: defaultBook,
      chapterId: defaultChapter,
    });
    bible.versions(apiKey).then((res) => {
      if (res.data) {
        const versions = filterVersions(res.data.data, language.toLowerCase());
        this.setState({
          versions,
          loadingVersions: false,
        });
      }
    });
    this.fetchBooks(defaultVersion);
    this.fetchChapters(defaultVersion, defaultBook);
    this.fetchBody(defaultVersion, defaultChapter);
  }

  setCurrent = (e, value, key) => {
    this.clearError();
    if (key === 'version') {
      this.updateVersion(value);
    } else if (key === 'book') {
      this.updateBook(value);
    } else if (key === 'chapter') {
      this.updateChapter(value);
    } else {
      this.setState({ hasError: true, errorText: 'invalid operation' });
    }
  };

  updateVersion = (versionId) => {
    const { bookId, chapterId, displayingSearch, searchTerm } = this.state;
    this.setState({ versionId });
    this.setState({ versionId });
    this.fetchBooks(versionId).then(() =>
      this.fetchChapters(versionId, bookId).then(() =>
        this.fetchBody(versionId, chapterId)
      )
    );

    if (displayingSearch) {
      this.fetchSearchResults(searchTerm);
    }
  };

  updateBook = (bookId, chapterId) => {
    const { versionId } = this.state;
    const chapter = chapterId || `${bookId}.1`;
    this.setState({
      bookId,
      chapterId: chapter,
      displayingSearch: false,
    });
    this.fetchChapters(versionId, bookId, chapterId);
    this.fetchBody(versionId, chapter);
  };

  fetchBooks = (versionId) => {
    const { apiKey } = this.state;
    this.setState({ loadingBooks: true });
    return bible.books(apiKey, versionId).then((res) => {
      if (res.data) {
        this.setState({ books: res.data.data, loadingBooks: false });
      }
    });
  };

  updateChapter = (chapterId) => {
    const { versionId } = this.state;
    this.setState({ chapterId, displayingSearch: false });
    return this.fetchBody(versionId, chapterId);
  };

  fetchChapters = (versionId, bookId, chapterId) => {
    const { apiKey, hasError, defaultBook } = this.state;
    this.setState({ loadingChapters: true });
    return bible.chapters(apiKey, versionId, bookId).then((res) => {
      if (res instanceof Error && !hasError) {
        this.updateBook(defaultBook);
        return this.setState({
          hasError: true,
          errorText: 'The selected book does not exist in this Bible version',
        });
      }
      return this.setChapter(res.data.data, chapterId);
    });
  };

  setChapter = (chapters, chapter) => {
    // Remove chapter intros
    chapters.shift();

    const chapterId = chapter || chapters.slice(0)[0].id;
    return this.setState({
      chapters,
      chapterId,
      loadingChapters: false,
    });
  };

  fetchBody = (versionId, chapterId) => {
    const { apiKey } = this.state;
    this.setState({ loadingBody: true });
    return bible.chapter(apiKey, versionId, chapterId).then((res) => {
      if (res.data) {
        this.setState({
          body: res.data,
          loadingBody: false,
        });
      }
    });
  };

  handleSearchSubmit = (search) => {
    this.setState({
      loadingSearchResults: true,
      displayingSearch: true,
      searchTerm: search,
    });
    return this.fetchSearchResults(search);
  };

  fetchSearchResults = (searchTerm) => {
    const { apiKey, versionId } = this.state;
    return bible.search(apiKey, versionId, searchTerm).then((res) => {
      if (res.data) {
        this.setState({
          loadingSearchResults: false,
          searchResults: res.data,
        });
      }
    });
  };

  clearError = () => this.setState({ hasError: false, errorText: '' });

  render() {
    const {
      hasError,
      errorText,
      versions,
      loadingVersions,
      versionId,
      books,
      loadingBooks,
      bookId,
      chapters,
      loadingChapters,
      chapterId,
      body,
      loadingBody,
      searchResults,
      loadingSearchResults,
      displayingSearch,
      terms,
    } = this.state;
    return (
      <>
        <Navigation
          versions={versions}
          loadingVersions={loadingVersions}
          versionId={versionId}
          books={books}
          loadingBooks={loadingBooks}
          bookId={bookId}
          chapters={chapters}
          loadingChapters={loadingChapters}
          chapterId={chapterId}
          setCurrent={this.setCurrent}
          handleSearchSubmit={this.handleSearchSubmit}
          displayingSearch={displayingSearch}
          terms={terms}
        />
        <Body
          hasError={hasError}
          errorText={errorText}
          loadingBody={loadingBody}
          body={body}
          searchResults={searchResults}
          loadingSearchResults={loadingSearchResults}
          displayingSearch={displayingSearch}
          updateBook={this.updateBook}
        />
      </>
    );
  }
}

export default App;
